import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCheckedPermission } from '../store/slices/permissionSlice';

export function useCheckPermission(streamHandler, device) {
  const dispatch = useDispatch();

  // Automatically request permissions when device changes, etc.
  useEffect(() => {
    if (!device) return;

    (async () => {
      const permissionsGranted = await streamHandler.permissionsRequested();
      if (permissionsGranted) {
        dispatch(setCheckedPermission(true));
      }
    })();
  }, [device, streamHandler, dispatch]);
}
